import { SsoLoginRequirement, WorkspaceLoginMfaRequirement, } from '@lucidlink/dto/validation';
import { WORKSPACE_ACCESS_REQUIREMENTS } from '#constants';
export const getWorkspaceLoginRequirements = (workspaceLoginStatus) => {
    const { isFullLoginRequired, isLoggedIn, mfaRequirement, ssoLoginRequirement, } = workspaceLoginStatus ?? {};
    return {
        isLoggedIn: Boolean(isLoggedIn),
        isSsoLoginRequired: ssoLoginRequirement === SsoLoginRequirement.REQUIRED,
        isMfaRequired: mfaRequirement === WorkspaceLoginMfaRequirement.REQUIRED,
        isFullLoginRequired: Boolean(isFullLoginRequired),
    };
};
export const deriveWorkspaceAccessRequirement = (workspaceLoginStatus) => {
    const { isFullLoginRequired, isLoggedIn, isMfaRequired, isSsoLoginRequired, } = getWorkspaceLoginRequirements(workspaceLoginStatus);
    if (isLoggedIn) {
        return null;
    }
    if (isFullLoginRequired) {
        return WORKSPACE_ACCESS_REQUIREMENTS.fullLogin;
    }
    if (isSsoLoginRequired) {
        return WORKSPACE_ACCESS_REQUIREMENTS.sso;
    }
    if (isMfaRequired) {
        return WORKSPACE_ACCESS_REQUIREMENTS.mfa;
    }
    return null;
};
